import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import env from './environment';

const browserHistory = createBrowserHistory({ window });
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: env.applicationInsightsKey,
    disableFetchTracking: false,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableAutoRouteTracking: true,
    correlationHeaderExcludePatterns: [/(?:stg-|test-)?auth.x-grab.net/],
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});
if (process.env.NODE_ENV !== 'development') {
  appInsights.loadAppInsights();
}
export { reactPlugin, appInsights };
